<template>
	<div class="saml-test-form">
		<v-card class="pa-4">
			<v-card-title>
				<h3>SAML Response Test Form</h3>
				<v-spacer></v-spacer>
			</v-card-title>
			
			<v-card-text>
				<form 
					ref="samlForm" 
					method="POST" 
					:action="submitUrl"
					@submit="onSubmit"
				>
					<!-- CSRF Token -->
					<input type="hidden" name="_token" :value="csrfToken" v-if="csrfToken">
					
					<div class="form-group mb-4">
						<v-textarea
							v-model="form.SAMLResponse"
							name="SAMLResponse"
							label="SAMLResponse"
							rows="8"
							outlined
							placeholder="Paste your SAML Response here..."
							class="mb-3"
							required
						/>
					</div>
					
					<div class="form-group mb-4">
						<v-text-field
							v-model="form.RelayState"
							name="RelayState"
							label="RelayState"
							outlined
							placeholder="Enter RelayState (optional)"
							class="mb-3"
						/>
					</div>
					
					<div class="form-actions">
						<v-btn
							type="submit"
							color="primary"
							large
							class="mr-3"
						>
							שלח SAML Response
						</v-btn>
						
						<v-btn
							type="reset"
							color="secondary"
							outlined
							large
						>
							נקה טופס
						</v-btn>
					</div>
				</form>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
export default {
	name: "SamlTestForm",
	data() {
		return {
			form: {
				SAMLResponse: '',
				RelayState: ''
			},
			submitUrl: '/login/saml2/callback',
			csrfToken: null
		};
	},
	mounted() {
		// Get CSRF token from meta tag
		const csrfMeta = document.querySelector('meta[name="csrf-token"]');
		if (csrfMeta) {
			this.csrfToken = csrfMeta.getAttribute('content');
		}
	},
	methods: {
		onSubmit() {
			// Just basic validation - let the form submit naturally
			if (!this.form.SAMLResponse.trim()) {
				alert('אנא הזן SAMLResponse');
				return false;
			}
			return true;
		}
	}
};
</script>

<style scoped>
.saml-test-form {
	max-width: 800px;
	margin: 0 auto;
	padding: 20px;
}

.form-group {
	margin-bottom: 16px;
}

.form-actions {
	display: flex;
	align-items: center;
	margin-top: 24px;
}

.response-text {
	background-color: #f5f5f5;
	padding: 16px;
	border-radius: 4px;
	white-space: pre-wrap;
	font-family: 'Courier New', monospace;
	font-size: 12px;
	max-height: 400px;
	overflow-y: auto;
}

.v-card {
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.v-textarea >>> .v-input__control textarea {
	font-family: 'Courier New', monospace;
	font-size: 12px;
}

/* RTL Support */
.saml-test-form {
	direction: rtl;
}

.response-text {
	direction: ltr;
	text-align: left;
}
</style>